import type { OutputData } from "@editorjs/editorjs";
import { z } from "zod";
import { ValidTypes } from "../ValidTypes";

export const GenericDataFormSchema = z.record(z.string(), z.any());

export type GenericDataForm = z.infer<typeof GenericDataFormSchema>;

export const FormValueSchema = z.object({
  fieldAlias: z.string(),
  value: z.any(),
});

export const FormSchema = z.object({
  formId: z.number(),
  values: z.array(FormValueSchema),
});

export const OptionSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type Option = z.infer<typeof OptionSchema>;

export const ValidationSchema = z.record(
  z.string(),
  z.any(),
  z.record(z.string(), z.any().optional())
);

export const FormContentSchema = FormSchema;

export type GenericData = z.infer<typeof GenericDataFormSchema>;

export type FormValue = z.infer<typeof FormValueSchema>;

export type FormContent = z.infer<typeof FormSchema>;

export const DEFAULT_INITIAL_DATA = {
  time: new Date().getTime(),
  blocks: [],
} as OutputData;

export type Validation = z.infer<typeof ValidationSchema>;

export const ChildPropsSchema = z.object({
  alias: z.string(),
  children: z.any().nullable(),
  required: z.boolean(),
  validations: z.array(ValidationSchema).default([]),
  excludeFromData: z.boolean().nullable(),
  fieldOptions: z.array(z.any()).nullable(),
  valueProp: z.string().nullable(),
});

export type ChildProps = z.infer<typeof ChildPropsSchema>;

export const FieldDataSchema = z.object({
  alias: z.string(),
  type: z.nativeEnum(ValidTypes),
  validations: z.array(ValidationSchema).default([]),
  fieldOptions: z.array(z.any()).nullable().optional(),
  valueProp: z.string().nullable().optional(),
});

export type FieldData = z.infer<typeof FieldDataSchema>;

export type ValidationFunction = (
  value: any,
  ...args: any[]
) => ErrorInfo | null;

export interface ErrorInfo {
  error: string;
  message: string;
}

export interface ErrorData {
  alias: string;
  type: string;
  validations?: Validation[];
  errors: ErrorInfo[];
}
